<template>
  <b-menu>
    <b-menu-list>
      <router-link to="/dashboard" class="menu-item">
        <b-icon
          class="is-inline-block mr-4 menu-icon"
          icon-pack="fa"
          icon="home"
          size="is-small"
        ></b-icon>
        <span>{{ $t("mp:sidebar.dashboard") }}</span>
      </router-link>

      <router-link to="/profile" class="menu-item" @click.native="onClick">
        <b-icon
          class="is-inline-block mr-4 menu-icon"
          icon-pack="fa"
          icon="user-cog"
          size="is-small"
        ></b-icon>
        <span>{{ $t("mp:sidebar.profile") }}</span>
      </router-link>

      <router-link
        v-if="canSeePurchases"
        to="/purchases"
        class="menu-item"
        @click.native="onClick"
        :class="{ 'router-link-active': purchaseActive }"
      >
        <b-icon
          class="is-inline-block mr-4 menu-icon"
          icon-pack="fa"
          icon="shopping-basket"
          size="is-small"
        ></b-icon>
        <span>{{ $t("mp:sidebar.purchases") }}</span>
      </router-link>

      <router-link
        v-if="canSeeBnplApplications"
        to="/bnpl-applications"
        class="menu-item"
        @click.native="onClick"
        :class="{ 'router-link-active': bnplApplicationActive }"
      >
        <b-icon
          class="is-inline-block mr-4 menu-icon"
          icon-pack="fa"
          icon="list"
          size="is-small"
        ></b-icon>
        <span>{{ $t("mp:sidebar.bnpl.applications") }}</span>
      </router-link>

      <router-link
        v-if="canSeeBnplApplications"
        to="/bnpl-prescores"
        class="menu-item"
        @click.native="onClick"
        :class="{ 'router-link-active': bnplPrescoreActive }"
      >
        <b-icon
          class="is-inline-block mr-4 menu-icon"
          icon-pack="fa"
          icon="list"
          size="is-small"
        ></b-icon>
        <span>{{ $t("mp:sidebar.bnpl.prescores") }}</span>
      </router-link>

      <router-link
        v-if="canSeeBnplApplications"
        to="/bnpl-b2b-applications"
        class="menu-item"
        @click.native="onClick"
        :class="{ 'router-link-active': bnplB2bApplicationActive }"
      >
        <b-icon
          class="is-inline-block mr-4 menu-icon"
          icon-pack="fa"
          icon="list"
          size="is-small"
        ></b-icon>
        <span>{{ $t("mp:sidebar.bnpl_b2b.applications") }}</span>
      </router-link>

      <router-link
        v-if="canSeeDeals"
        to="/deals"
        class="menu-item"
        @click.native="onClick"
        :class="{ 'router-link-active': dealActive }"
      >
        <b-icon
          class="is-inline-block mr-4 menu-icon"
          icon-pack="fa"
          icon="file-invoice-dollar"
          size="is-small"
        ></b-icon>
        <span>{{ $t("mp:sidebar.deals") }}</span>
      </router-link>

      <router-link v-if="isLimitActive" to="/limits" class="menu-item" @click.native="onClick">
        <b-icon
          class="is-inline-block mr-4 menu-icon"
          icon-pack="fa"
          icon="file-invoice-dollar"
          size="is-small"
        ></b-icon>
        <span>{{ $t("mp:sidebar.limit") }}</span>
      </router-link>

      <router-link v-if="isCustomerLimitActive" to="/customer-limits" class="menu-item">
        <b-icon
          class="is-inline-block mr-4 menu-icon"
          icon-pack="fa"
          icon="file-invoice-dollar"
          size="is-small"
        ></b-icon>
        <span>{{ $t("mp:sidebar.customer_limits") }}</span>
      </router-link>

      <router-link
        v-if="canSeeDelayedTransactions"
        to="/delayed-transactions"
        class="menu-item"
        @click.native="onClick"
      >
        <b-icon
          class="is-inline-block mr-4 menu-icon"
          icon-pack="fa"
          icon="money-bill-wave"
          size="is-small"
        ></b-icon>
        <span>{{ $t("mp:sidebar.delayed_transaction") }}</span>
      </router-link>

      <router-link
        v-if="canSeeApiKeys"
        to="/keys"
        class="menu-item"
        @click.native="onClick"
      >
        <b-icon
          class="is-inline-block mr-4 menu-icon"
          icon-pack="fa"
          icon="code"
          size="is-small"
        ></b-icon>
        <span>{{ $t("mp:sidebar.api_keys") }}</span>
      </router-link>

      <router-link
        v-if="canSeeUsers"
        to="/users"
        class="menu-item"
        @click.native="onClick"
        :class="{ 'router-link-active': userActive }"
      >
        <b-icon
          class="is-inline-block mr-4 menu-icon"
          icon-pack="fa"
          icon="users"
          size="is-small"
        ></b-icon>
        <span>{{ $t("mp:sidebar.users") }}</span>
      </router-link>

      <router-link
        v-if="canSeeApplications"
        to="/applications"
        class="menu-item"
        @click.native="onClick"
        :class="{ 'router-link-active': applicationActive }"
      >
        <b-icon
          class="is-inline-block mr-4 menu-icon"
          icon-pack="fa"
          icon="list"
          size="is-small"
        ></b-icon>
        <span>{{ $t("mp:sidebar.applications") }}</span>
      </router-link>

      <router-link
        v-if="canSeeMyApplication"
        to="/application"
        class="menu-item"
        @click.native="onClick"
      >
        <b-icon
          class="is-inline-block mr-4 menu-icon"
          icon-pack="fa"
          icon="edit"
          size="is-small"
        ></b-icon>
        <span>{{ $t("mp:sidebar.application") }}</span>
      </router-link>
    </b-menu-list>
  </b-menu>
</template>

<script>
import { AUTHORITIES } from "@/utils/authorities";
import { mapActions, mapGetters } from "vuex";
import { BNPL_INSTANCE_TYPE } from "@/utils/const";

const APPLICATION_VISIBLE_POLL_MS = 60000;

export default {
  name: "MenuContent",
  async created() {
    await this.fetchMyApplicationVisible();

    this.applicationVisiblePoll = window.setInterval(() => {
      this.fetchMyApplicationVisible();
    }, APPLICATION_VISIBLE_POLL_MS);
    await this.fetchIsLimit();
  },
  destroyed() {
    window.clearInterval(this.applicationVisiblePoll);
  },
  data() {
    return {
      applicationVisiblePoll: null,
      isPurchaseListEmpty: true,
    };
  },
  methods: {
    ...mapActions({
      fetchMyApplicationVisible: "application/fetchMyApplicationVisible",
      fetchIsLimit: "customerLimit/fetchIsLimit",
    }),
    onClick() {
      this.$emit("click");
    },
  },
  computed: {
    ...mapGetters({
      canSeeMyApplication: "application/isApplicationButtonVisible",
      getBnplInstanceType: "uiConfigStore/getBnplInstanceType",
      isLimitActive: "customerLimit/isLimit",
      isCustomerLimitActive: "customerLimit/isCustomerLimit",
    }),
    purchaseActive() {
      return this.$route.fullPath.includes("purchase");
    },
    dealActive() {
      return this.$route.fullPath.includes("deal");
    },
    userActive() {
      return this.$route.fullPath.includes("user");
    },
    applicationActive() {
      return this.$route.fullPath.includes("/application");
    },
    bnplApplicationActive() {
      return this.$route.fullPath.includes("bnpl-application");
    },
    bnplB2bApplicationActive() {
      return this.$route.fullPath.includes("bnpl-b2b-applications");
    },
    bnplPrescoreActive() {
      return this.$route.fullPath.includes("bnpl-prescore");
    },
    canSeePurchases() {
      const authorities = this.$store.getters["session/hasAnyAuthority"]([
        AUTHORITIES.PURCHASE.LIST,
        AUTHORITIES.PURCHASE.ADMIN,
      ]);

      return authorities && !this.isPurchaseListEmpty;
    },
    canSeeDeals() {
      // Deals were removed
      return false;
    },
    canSeeApiKeys() {
      return this.$store.getters["session/hasAnyAuthority"]([
        AUTHORITIES.API_KEY.LIST,
        AUTHORITIES.API_KEY.ADMIN,
      ]);
    },
    canSeeUsers() {
      return this.$store.getters["session/hasAnyAuthority"]([
        AUTHORITIES.USER.LIST,
        AUTHORITIES.USER.ADMIN,
      ]);
    },
    canSeeApplications() {
      return this.$store.getters["session/hasAnyAuthority"]([
        AUTHORITIES.APPLICATION.LIST,
        AUTHORITIES.APPLICATION.ADMIN,
      ]);
    },
    canSeeBnplApplications() {
      return this.$store.getters["session/hasAnyAuthority"]([
        AUTHORITIES.BNPL.APPLICATION.LIST,
        AUTHORITIES.BNPL.APPLICATION.ADMIN,
      ]);
    },
    canSeeDelayedTransactions() {
      return (
        this.getBnplInstanceType &&
        this.getBnplInstanceType === BNPL_INSTANCE_TYPE.MERCHANT_FINANCE
      );
    },
  },
  async beforeCreate() {
    this.isPurchaseListEmpty =
      (await this.$store.getters["purchase/getList"].values.length) === 0;
    await this.$store.dispatch("purchase/fetchList");
    this.isPurchaseListEmpty =
      (await this.$store.getters["purchase/getList"].values.length) === 0;
  },
};
</script>
